export default "__VITE_ASSET__DWrNPIvg__"